import { PropsWithChildren, ReactNode } from 'react';
import { Backdrop } from '@mui/material';

import { Loader } from '~/components/atoms/loader/Loader';

type BackdropFullScreenProps = PropsWithChildren<{
  isLoading: boolean;
}>;

export const BackdropFullScreen = ({ children, isLoading }: BackdropFullScreenProps) => {
  return (
    <>
      <Backdrop open={isLoading} sx={{ color: '#fff', zIndex: 1300, backgroundColor: 'rgb(255 255 255 / 80%)' }}>
        <Loader />
      </Backdrop>
      {children}
    </>
  );
};
